import {
  call,
  put,
  takeLatest,
  race,
  take,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import Api from 'api';
import {
  SCA_POLL_LOCAL_REQUEST,
  SCA_POLL_LOCAL_DONE,
  SCA_START_RECIPIENT_ENROLLMENT,
  SCA_SYNC_RECIPIENT_RESET,
  SCA_POLL_LOCAL_RESET,
} from '../constants';
import * as actions from '../actions';

export function* pollLocalWorker() {
  const attempts = 5;
  const intervalMs = 2000;

  for (let i = 0; i < attempts; i += 1) {
    try {
      const status = yield call(Api.fetchBankStatus);
      const ready = status?.ready === true;
      if (ready) {
        yield put({ type: SCA_POLL_LOCAL_DONE, payload: status });
        if (actions.fetchUserSelfRequest) {
          yield put(actions.fetchUserSelfRequest());
        }
        return;
      }
    } catch { /* ignore */ }
    const { cancelled } = yield race({
      t: delay(intervalMs),
      cancelled: take([
        SCA_START_RECIPIENT_ENROLLMENT,
        SCA_SYNC_RECIPIENT_RESET,
        SCA_POLL_LOCAL_RESET,
      ]),
    });
    if (cancelled) return;
  }

  yield put({ type: SCA_POLL_LOCAL_DONE, payload: null });
}

export function* watchPollLocal() {
  yield takeLatest(SCA_POLL_LOCAL_REQUEST, pollLocalWorker);
}

export default [watchPollLocal()];
